import React from 'react';
import { ThemeProvider, createGlobalStyle } from 'styled-components';
import Layout from './Layout';
import { AppContext } from '../context';
import theme from '../theme';

const GlobalStyle = createGlobalStyle`
  html, body {
    margin: 0;
    font-family: ${props => props.theme.font.circular};
    font-size: ${props => props.theme.fontSize.normal};
    color: ${props => props.theme.text.normal};
    height: 100%;
    min-height: 100%;
    background-color: ${props => props.theme.background.normal};
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  #root {
    min-height: 100vh;
  }
  *, *:before, *:after {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  button {
    font-family: Circular;
    border: none;
    background: none;
    &:focus {
      outline: none;
    }
  }
`;

const App = () => (
  <ThemeProvider theme={theme}>
    <AppContext.Provider>
      <React.Fragment>
        <GlobalStyle />
        <Layout />
      </React.Fragment>
    </AppContext.Provider>
  </ThemeProvider>
);

export default App;
